import { DolezitostAktEuApi, DolezitostEnum } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new DolezitostAktEuApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const changeDolezitost = async (
  type: string,
  year: number,
  index: number,
  dolezitost: DolezitostEnum,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.setDolezitost(type, year, index, { dolezitost }, headers);
  return { responseCode: status };
};
